import InvestRatingPage from './InvestRatingPage';

export default InvestRatingPage;
